<template>
	<div>
		<button class="better-mobile-btn" v-on:click="startScanning" :class="rfid ? 'grey-background' : ''">
			<HandIcon/>
			{{ rfid ? "Re-Scan Wristband" : "Scan Wristband" }}
		</button>

		<div v-if="scanningRfid" class="fullscreen-overlay">
			<h2 class="overlay-header">{{ user_name }}</h2>

			<div class="overlay-body">
				<h5 class="p-05">{{ credential_title }}</h5>

				<div>
					<div v-if="awaitingScan" class="p-05">
						<LoadingDots/>
						<p>Press the RFID against the reader</p>
					</div>

					<p v-else>Place the wristband on the patron and press the button below</p>

					<div class="p-05">
						<button
							:disabled="awaitingScan"
							class="better-mobile-btn"
							v-on:click="complete">
							{{ awaitingScan ? "Scanning RFID..." : "Placed Wristband on Patron" }}
						</button>
					</div>

					<div v-if="allowFakeRFID && awaitingScan" class="p-05">
						<button
							class="better-mobile-btn"
							v-on:click="addFakeRFID">
							Add Fake TEST RFID
						</button>
					</div>
				</div>

				<div class="p-1">
					<button class="better-mobile-btn red" v-on:click="back">Back</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HandIcon from "./icons_svg/HandIcon.vue";
import LoadingDots from "./icons_svg/LoadingDots.vue";

export default {
	name: 'ScanRFIDButton',
	inject: ['rfidService'],
	components: {
		HandIcon,
		LoadingDots
	},
	props: {
		user_name: {
			type: String,
			required: true
		},
		credential_title: {
			type: String,
			required: true
		},
		initial_value: {
			type: String,
			default: ""
		},
	},
	data() {
		return {
			shouldEmit: false,
			rfid: this.initial_value,
			scanningRfid: false,
			awaitingScan: true,
			rfidScanHandler: null,
		}
	},
	computed: {
		hasNFC() {
			return this.rfidService.doesDeviceHaveNFC()
		},
		allowFakeRFID() {
			return process.env.VUE_APP_ENV === 'development' || process.env.VUE_APP_ENV === 'staging'
		},
	},
	methods: {
		async startScanning() {
			this.clearRfidSubscription()
			this.scanningRfid = true;
			this.awaitingScan = true;
			this.shouldEmit = true;

			this.rfidScanHandler = ({rfid}) => {
				if (this.awaitingScan && this.shouldEmit) {
					this.shouldEmit = false;
					this.clearRfidSubscription()
					this.rfid = rfid
					this.$emit('onValidate', rfid);
				}
			}
			this.rfidService.once('rfid:scanned', this.rfidScanHandler)

			if (!this.hasNFC && this.allowFakeRFID) {
				return
			}

			const connected = await this.rfidService.connectReader()
			if (!connected && !this.allowFakeRFID) {
				this.resetState()
			}
		},
		proceedAfterValidation() {
			this.awaitingScan = false;
		},
		addFakeRFID() {
			this.clearRfidSubscription()
			this.rfid = 'rfid_test_' + Date.now()
			this.$emit('onValidate', this.rfid);
		},
		complete() {
			this.$emit('onScannedRfid', this.rfid);
			this.resetState();
		},
		resetState() {
			this.clearRfidSubscription()
			this.shouldEmit = false;
			this.rfid = '';
			this.scanningRfid = false
			this.awaitingScan = false
		},
		clearRfidSubscription() {
			if (this.rfidScanHandler) {
				this.rfidService.off('rfid:scanned', this.rfidScanHandler)
				this.rfidScanHandler = null
			}
		},
		back() {
			this.resetState()
			this.$emit('back')
		},
	},
	beforeDestroy() {
		this.clearRfidSubscription()
	}
}
</script>

<style scoped>
.scan-rfid .loading-message {
	animation: pulse 1.65s infinite linear;
}

.grey-background {
	background: #666 !important;
}
</style>
